import React from 'react';
import { FaPlay } from 'react-icons/fa'; // Import play icon from react-icons

// Import images
import event1 from '../img/envision/padcost/poadcostimage1.JPG';
import event2 from '../img/envision/padcost/padcostimge2.JPG';
import newsupdate from '../img/envision/padcost/paodcostimage3.JPG';

const Poadcostvideossections = () => {
  return (
    <div style={styles.app}>
      <div style={styles.cardContainer}>
        {/* First Card */}
        <div style={styles.card}>
          <div style={styles.playButtonContainer}>
            <FaPlay style={styles.playButton} />
          </div>
          <img src={event1} alt="Event 1" style={styles.cardImage} />
          <h3 style={styles.cardTitle}>ALWAYS PUTTING VALUES FIRST
         </h3>
          <CardDescription
            description=" By Envision - 06 Apr, 2023"
          />
        </div>

        {/* Second Card */}
        <div style={styles.card}>
          <div style={styles.playButtonContainer}>
            <FaPlay style={styles.playButton} />
          </div>
          <img src={event2} alt="Event 2" style={styles.cardImage} />
          <h3 style={styles.cardTitle}>Building a Digital DNA
         </h3>
          <CardDescription
            description=" By Envision - 30 Sep, 2020"
          />
        </div>

        {/* Third Card */}
        <div style={styles.card}>
          <div style={styles.playButtonContainer}>
            <FaPlay style={styles.playButton} />
          </div>
          <img src={newsupdate} alt="News Update" style={styles.cardImage} />
          <h3 style={styles.cardTitle}>Designing Industries of Tomorrow
         </h3>
          <CardDescription
            description=" By Envision - 11 Sep, 2020"
          />
        </div>
      </div>
    </div>
  );
};

// Card Description Component to display the full content
const CardDescription = ({ description }) => {
  return <p style={styles.cardDescription}>{description}</p>;
};

// Styles for the card components
const styles = {
  app: {
    textAlign: 'center',
    padding: '20px',
    backgroundColor: '#f7f7f7',
    minHeight: '100vh',
  },
  cardContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  card: {
    width: '300px',
    border: '1px solid #ddd',
    borderRadius: '10px',
    padding: '15px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    margin: '15px',
    textAlign: 'center',
    backgroundColor: '#fff',
    position: 'relative', // Ensures the play button is positioned relative to the card
  },
  playButtonContainer: {
    position: 'absolute',
    top: '32%', // Center vertically
    left: '50%', // Center horizontally
    transform: 'translate(-50%, -50%)', // Adjust to exactly center the button
    zIndex: 1, // Ensures the play button is on top of the image
  },
  playButton: {
    fontSize: '3em', // Increase size for better visibility
    color: '#fff',
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    borderRadius: '50%',
    padding: '15px', // Increase padding to make the button larger
    cursor: 'pointer',
  },
  cardImage: {
    width: '100%',
    height: '200px',
    objectFit: 'cover',
    borderRadius: '10px',
    position: 'relative',
  },
  cardTitle: {
    fontSize: '1.5em',
    margin: '10px 0',
    // textAlign:'justify'
  },
  cardDescription: {
    fontSize: '1em',
    margin: '10px 0',
    textAlign: 'center',
  },
};

export default Poadcostvideossections;
